import React from "react";
import classNames from "classnames";
import { ODSIconProps } from "../ODSIcon.types";
import "@/css/icons/ODSIcon.css";

const ODSCheckmark = ({
  size,
  fill = "currentColor",
  color = "currentColor",
  selected = false,
  decorative = false,
  accessibilityTitle,
  focusable = false,
  small = false,
  className,
  ...rest
}: ODSIconProps) => {
  const computedSize = size || (small ? 16 : 24);

  return (
    <svg
      className={classNames("ODSIcon", className)}
      xmlns="http://www.w3.org/2000/svg"
      width={computedSize}
      height={computedSize}
      viewBox={small ? "0 0 16 16" : "0 0 24 24"}
      aria-hidden={decorative ? true : false}
      tabIndex={focusable ? 0 : -1}
      {...rest}
    >
      {accessibilityTitle && <title>{accessibilityTitle}</title>}
      <g fill={fill === "currentColor" ? color : fill}>
        {selected ? (
          small ? (
            <g>
              <path
                fillRule="evenodd"
                d="M14.564 3.653a.8.8 0 0 1 0 1.131l-7.56 7.56a.8.8 0 0 1-1.131 0L2.436 8.909a.8.8 0 0 1 1.132-1.131l2.87 2.87 6.995-6.994a.8.8 0 0 1 1.131 0"
                clipRule="evenodd"
              />
            </g>
          ) : (
            <g>
              <path
                fillRule="evenodd"
                d="M21.384 5.616a1.25 1.25 0 0 1 0 1.768l-11 11a1.25 1.25 0 0 1-1.768 0l-5-5a1.25 1.25 0 0 1 1.768-1.768L9.5 15.732 19.616 5.616a1.25 1.25 0 0 1 1.768 0"
                clipRule="evenodd"
              />
            </g>
          )
        ) : small ? (
          <g>
            <path
              fillRule="evenodd"
              d="M14.423 3.794a.6.6 0 0 1 0 .849l-7.56 7.56a.6.6 0 0 1-.849 0L2.578 8.767a.6.6 0 0 1 .849-.849l3.012 3.012 7.136-7.136a.6.6 0 0 1 .848 0"
              clipRule="evenodd"
            />
          </g>
        ) : (
          <g>
            <path
              fillRule="evenodd"
              d="M21.207 5.793a1 1 0 0 1 0 1.414l-11 11a1 1 0 0 1-1.414 0l-5-5a1 1 0 1 1 1.414-1.414L9.5 16.086 19.793 5.793a1 1 0 0 1 1.414 0"
              clipRule="evenodd"
            />
          </g>
        )}
      </g>
    </svg>
  );
};

export default ODSCheckmark;
